import * as React from 'react'
import { SocialButtons } from '../../../../shared/buttons'
import styled from 'styled-components'

export type PropsType = {
  isConnected: boolean,
  linkAccountRequestInProgress: boolean,
  isLoading: boolean
}

export type DispatchPropsType = {
  toggleFacebookConnection: (isConnected: boolean) => void
}

export default function LinkFacebook (props: PropsType & DispatchPropsType): React.ReactNode {
  return (
    <SocialButtons
      onClick={(): void => {
        props.toggleFacebookConnection(props.isConnected)
      }}
      disabled={props.linkAccountRequestInProgress}
      isOutlineStyle={true}
    >
      <FacebookIcon alt='Login with Facebook' src='/images/facebook-icon2x.png'/>
      {props.isConnected ? 'Disconnect' : 'Connect'}{props.isLoading && 'ing'} Facebook
    </SocialButtons>
  )
}

const FacebookIcon = styled.img<any>`
  width: 18px;
  height: 18px;
  margin-right: 8px;
`
